
import { AuthorForumTopicsModel } from '../models/AuthorForumTopicsModel.js';
import { AuthorForumTopicsView } from '../views/AuthorForumTopicsView.js';

export class AuthorForumTopicsController {
    constructor() {

        this.model = new AuthorForumTopicsModel();
        this.view = new AuthorForumTopicsView();

        this.model.subscribe(state => this.view.render(state));
    }
}